import React, { useState, useContext, useEffect, useRef } from "react";
import Navbar from "../../components/NavBar";
import Footer from "../../components/Footer";
import Button from "react-bootstrap/esm/Button";
import Table from "react-bootstrap/Table";
import Form from "../../../node_modules/react-bootstrap/Form";
import Modal from "react-bootstrap/esm/Modal";
import AppContext from "../../context/AppContext";
import { Link } from "react-router-dom";
import { MODULES } from "../../utils/routesNames";
import DatePicker from "react-datepicker";
import { Formik, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import momentTZ from "moment-timezone";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import {
  CustomerCheckout,
  ViewCartService,
  RemoveProductFromCartService,
  GetPublicHolidays,
  ClearCart,
} from "../../services/services";
import { OrderCheckout } from "../../modals/OrderCheckout";
import { CartProducts } from "../../modals/Cart";
import { MODAL_CLOSE } from "../../assets/images/images";
import {
  ADD_PRIMARY,
  EMPTY_CART,
  SUCCESSFULL_ORDER,
  BIN,
} from "../../assets/images/svgImage";
import {
  generalMessages as MSG,
  checkoutMessages,
} from "../../utils/constants";
import UpdatableField from "./updatableField";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/esm/Spinner";
import { Appearance, loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./checkoutForm";
import Loader from "../../components/Loader";
import { NO_IMG } from "../../assets/images/images";
import { isValidImageUrl } from "../../utils/common";

if (!process.env.REACT_APP_STRIPE_PUBLIC) {
  throw new Error("STRIPE_PUBLIC is not defined in environment variables");
}
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC!);

const Cart: React.FC = () => {
  const { cart, cartTotals, setCart, setCartTotals, tokenExpired } = useContext(AppContext);
  const [show, setShow] = useState(false);
  const [holidayDates, setHolidayDates] = useState<Date[]>([]);
  const [clientSecret, setClientSecret] = useState("");
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);
  const [paymentMessage, setPaymentMessage] = useState("");
  const [isSyncing, setIsSyncing] = useState(false);
  const formikRef = useRef<any>(null);

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        const holidays = await GetPublicHolidays();
        const holidayDateObjects = holidays.map((data) => new Date(data.date));
        setHolidayDates(holidayDateObjects);
      } catch (error) {
        console.error("Failed to fetch holidays:", error);
      }
    };
    fetchHolidays();
    const query = new URLSearchParams(window.location.search);
    const paymentIntentParam = query.get("payment_intent");
    const paymentIntentClientSecretParam = query.get(
      "payment_intent_client_secret"
    );
    const redirectStatusParam = query.get("redirect_status");

    if (paymentIntentParam && paymentIntentClientSecretParam) {
      window.history.replaceState({}, document.title, window.location.pathname);
      setShow(true);
      if (redirectStatusParam === "succeeded") {
        setDataFetched(false);
        setPaymentSuccess(true);
        setTimeout(() => {
          ViewCartService()
            .then((result) => {
              if (result.data.flag) {
                setCart(result.data.data);
                setCartTotals(result.data.total_summary);
                setDataFetched(true);
                setShow(false);
              }
            })
            .catch((err) => {
              if (err.response.status === 401) {
                tokenExpired();
              }
            });
        }, 5000);
      } else if (redirectStatusParam === "processing") {
        setPaymentMessage("Payment processing.");
      } else {
        setPaymentMessage("Payment failed, Please try again later.");
      }
    } else {
      ViewCartService()
        .then((result) => {
          if (result.data.flag) {
            setCart(result.data.data);
            setCartTotals(result.data.total_summary);
            setDataFetched(true);
          }
        })
        .catch((err) => {
          if (err.response.status === 401) {
            tokenExpired();
          }
        });
    }
  }, []); // eslint-disable-line

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);

    if (formikRef.current) {
      formikRef.current.setSubmitting(false);
    }
  };

  const handleExited = () => {
    setClientSecret("");
    setPaymentSuccess(false);
    setPaymentMessage("");
  };
  const todayDate = new Date();

  const getNextValidDeliveryDate = () => {
    let nextDate = new Date();
    nextDate.setDate(nextDate.getDate() + 1);

    const holidayStrings = holidayDates.map((d) => d.toDateString());

    // Keep incrementing the date until it's not a sunday, not today, and not a holiday
    while (
      nextDate.getDay() === 0 ||
      holidayStrings.includes(nextDate.toDateString())
    ) {
      nextDate.setDate(nextDate.getDate() + 1);
    }

    return nextDate;
  };

  const tomorrow = getNextValidDeliveryDate();

  const checkoutSchema = Yup.object({
    deliveryDate: Yup.date()
      .nullable()
      .required(checkoutMessages.DATE_REQUIRED)
  });

  const clearCart = () => {
    const confirmClear = window.confirm("Are you sure you want to clear cart?");

    if(confirmClear){
      ClearCart().then((result) => {
        if(result.data.flag){
          setCart(result.data.data);
          toast.success(result.data.message);
        }else {
          toast.error(MSG.ERROR_MSG);
        }
      });
    }
  }

  // delete item from cart.
  const removeItem = (item: CartProducts) => {
    RemoveProductFromCartService(item.id.toString())
      .then((result) => {
        if (result.data.flag) {
          toast.success(result.data.message);
        } else {
          toast.error(MSG.ERROR_MSG);
        }
        return ViewCartService();
      })
      .then((result) => {
        if (result.data.flag) {
          setCart(result.data.data);
          setCartTotals(result.data.total_summary);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          tokenExpired();
        }
      });
  };

  const checkoutCustomer = (checkoutValues: {
    deliveryDate: Date | null;
    comments: string;
  }) => {
    const formattedData = formatValues(checkoutValues);
    if (!formattedData) {
      if (formikRef.current) {
        formikRef.current.setSubmitting(false);
      }

      return;
    };

    CustomerCheckout(formattedData)
      .then((result) => {
        if (result.data.flag) {
          const checkoutData = result.data.data;

          if (checkoutData.pre_payment) {
            setClientSecret(checkoutData.clientSecret);
          }

          handleShow();

          // MUST return this promise so the next .then gets the result
          return ViewCartService();
        }

        toast.error(result.data.message);
        formikRef.current?.setSubmitting(false);

        // Stop the chain
        return Promise.reject({ handled: true });
      })
      .then((result) => {
        if (result.data.flag) {
          setCart(result.data.data);
          setCartTotals(result.data.total_summary);
        }
      })
      .catch((err) => {
        if (err?.handled) return; // Already handled above
        if (err && err.response.status === 422) {
          toast.error(err.response.data.message);
          if (formikRef.current) {
            formikRef.current.setSubmitting(false);
          }
        }
        if (err && err.response.status === 401) {
          tokenExpired();
        }
      });
  };

  const formatValues = (formikValues: {
    deliveryDate: Date | null;
    comments: string;
  }) => {
    const { deliveryDate } = formikValues;
    if (!deliveryDate) {
      toast.error("Delivery date is required.");
      return;
    } 

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const deliveryDateTime = new Date(deliveryDate);
    deliveryDateTime.setHours(0, 0, 0, 0);

    if (deliveryDateTime.getTime() <= today.getTime()) {
      toast.error("Delivery date must be after today.");
      return;
    }

    const currentDateTime = momentTZ()
      .tz("Australia/Melbourne")
      .format("DD-MM-YYYY HH:mm:ss");
    const formattedValues: OrderCheckout = {
      orderDate: currentDateTime,
      expectedDeliveryDate:
        (formikValues.deliveryDate &&
          formattedDate(formikValues.deliveryDate)) ||
        "",
      comments: formikValues.comments,
      subTotal: cartTotals['sub_total'].toFixed(2),
      shipping: 50,
      grandTotal: cartTotals['final_total'].toFixed(2),
      products: cart.map((item) => {
        return {
          product_id: item.product_id,
          product_name: item.product_name,
          price: item.product_price,
          quantity: item.quantity,
          total_price: item.total_price,
          product_tax: item.product_tax,
        };
      }),
    };
    return formattedValues;
  };

  const formattedDate = (date: Date) => {
    let month = String(date.getMonth() + 1);
    let day = String(date.getDate());
    const year = String(date.getFullYear());

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return `${day}-${month}-${year}`;
  };

  const message = () => {
    let today = moment(),
      dayOfWeek = today.day(),
      msg =
        "Thank you, your order has been submitted and will be dispatched by your supplier soon, for exact delivery timeframe please contact them directly. Please check your email for order details and a to link to this order's invoice.\n\n";

    let isWorkingDay = dayOfWeek !== 0;
    let isWorkingHours = false;
    if (isWorkingDay) {
      isWorkingHours = today.isBefore(moment("7:00pm", "hh:mma"));
      if (!isWorkingHours) {
        msg =
          "Please place orders prior to 7.00pm. Anything placed after this will not be dispatched the following day.";
      }
    }

    return msg;
  };

  const renderModalContent = () => {
    if (clientSecret && !paymentSuccess) {
      return (
        <>
          <Button className="btn btn-icon" onClick={handleClose}>
            <img src={MODAL_CLOSE} alt="close" />
          </Button>
          <Elements
            stripe={stripePromise}
            options={{ clientSecret, appearance, loader }}
          >
            <CheckoutForm onClose={handleClose} />
          </Elements>
        </>
      );
    }

    return (
      <>
        <Button className="btn btn-icon" onClick={handleClose}>
          <img src={MODAL_CLOSE} alt="close" />
        </Button>
        {paymentMessage ? (
          <h4 className="event-title">{paymentMessage}</h4>
        ) : (
          <>
            <img
              className="event-img"
              src={SUCCESSFULL_ORDER}
              alt="orderSuccess"
            />
            <h4 className="event-title">Your order has been submitted</h4>
            <p className="event-description">{message()}</p>
            {paymentSuccess && (
              <h6 className="event-description">
                * Please do not refresh the page
              </h6>
            )}
          </>
        )}
      </>
    );
  };

  const appearance: Appearance = {
    theme: "stripe",
  };

  const loader = "auto";

  return (
    <div>
      <div className="wrapper">
        <div className="sticky-header">
          <Navbar />
        </div>
        {dataFetched ? (
          cart.length === 0 ? (
            <section className="empty-cart-block">
              <div className="main-block">
                <img src={EMPTY_CART} alt="EmptyCart" />
                <h3>Sorry, your cart is empty</h3>
                <p>Looks like you have not added any products</p>
                <Button as={Link} to={MODULES.allProducts.url} variant="accent">
                  add product into cart
                </Button>
              </div>
            </section>
          ) : (
            <section className="page-block my-cart-block">
              <div className="container-xl">
                <h3 className="page-title">My Cart</h3>
                <div className="row">
                  <div className="col-lg-8">
                    <div className="table-responsive mb-2">
                      <Table className="primary-grid" responsive="lg">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Product</th>
                            <th>Qty.</th>
                            <th className="text-right">Unit Price/GST</th>
                            <th className="text-right">Total</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {cart.map((item) => (
                          <React.Fragment key={item.id}>
                            <tr>
                              <td>
                                <img className="product-image-cart"
                                  onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.src = NO_IMG;
                                  }}
                                  src={isValidImageUrl(item.product_image) ? item.product_image : NO_IMG}
                                  alt={item.product_image}
                                />
                              </td>
                              <td>
                                {item.product_name}
                                {item.allergen_images.length > 0 && (
                                  <div className="d-flex align-items-center flex-wrap mt-2 mb-3 gap-1">
                                    {item.allergen_images.map((icon, index) => ( 
                                        <img
                                          key={index}
                                          src={icon}
                                          alt={`allergen-${index}`}
                                          onError={(e) => (e.currentTarget.src = NO_IMG)}
                                          className="img-fluid rounded mr-2"
                                          style={{ width: "30px", height: "30px", objectFit: "contain" }}
                                        />
                                      )
                                    )}
                                  </div>
                                )}
                              </td>
                              <td>
                                <UpdatableField {...item} setIsSyncing={setIsSyncing} />
                              </td>
                              <td className="text-right" width={160}>
                                $ {item.product_price} / $ {item.product_tax > 0 ? (item.product_price / item.product_tax).toFixed(2) : 0}
                              </td>
                              <td className="text-right" width={140}>
                                $ {item.total_price.toFixed(2)}
                              </td>
                              <td className="text-right">
                                <Button
                                  className="btn btn-icon danger"
                                  onClick={() => removeItem(item)}
                                >
                                  <img src={BIN} alt="remove" />
                                </Button>
                              </td>
                            </tr>
                            {item.is_cut_off_time_completed && (
                              <tr>
                                <td colSpan={6} className="cutoff-time-message">
                                  Today's order cutoff has passed, earliest delivery time is the day after tomorrow
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    <Button
                      as={Link}
                      to={MODULES.allProducts.url}
                      className="btn btn-stroke btn-iconic-text"
                    >
                      <img src={ADD_PRIMARY} alt="Add" />
                      <span>add more product</span>
                    </Button>

                    <Button className="btn btn-iconic-danger ml-4" onClick={clearCart} variant="danger">
                      <img src={BIN} alt="remove" />
                      <span>Clear Cart</span>
                    </Button>

                    <div className="total-block">
                      <div className="price-block total">
                        <p>Sub Total</p>
                        <p>$ {cartTotals['sub_total'].toFixed(2)}</p>
                      </div>
                      <div className="price-block total">
                        <p>GST</p>
                        <p>$ {cartTotals['total_tax'].toFixed(2)}</p>
                      </div>
                      {(cartTotals['repayment_amount'] && cartTotals['repayment_amount']) ? (
                        <div className="price-block total">
                          <p>Repayment Amount</p>
                          <p>$ {cartTotals['repayment_amount'].toFixed(2)}</p>
                        </div>
                      ) : null}
                      <hr></hr>
                      <div className="price-block total">
                        <p>Total</p>
                        <p>$ {cartTotals['final_total'].toFixed(2)}</p>
                      </div>
                      <div
                        className="price-block alert alert-danger"
                        role="alert"
                      >
                        <span className="warning">
                          This is not an official invoice, invoice issued upon
                          delivery
                        </span>
                      </div>
                      <span className="font-weight-bold">
                        Minimum order amount for Saturday delivery is $500
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="checkout-block">
                      <Formik
                        innerRef={formikRef}
                        validateOnChange
                        validateOnBlur
                        validationSchema={checkoutSchema}
                        initialValues={{
                          deliveryDate: null,
                          comments: "",
                        }}
                        onSubmit={(values, formikHelpers) => {
                          formikRef.current = formikHelpers;
                          checkoutCustomer(values)
                        }}
                      >
                        {({
                          handleSubmit,
                          handleChange,
                          values,
                          touched,
                          errors,
                          handleBlur,
                          isSubmitting,
                          setFieldValue,
                        }) => (
                          <FormikForm onSubmit={handleSubmit}>
                            <Form.Group className="form-group">
                              <DatePicker
                                name="deliveryDate"
                                selected={values.deliveryDate}
                                value={values.deliveryDate}
                                onChange={(date) => {
                                  setFieldValue("deliveryDate", date);
                                }}
                                minDate={tomorrow}
                                filterDate={(date) => {
                                  const isSunday = date.getDay() === 0;
                                  const isToday =
                                    date.getDate() === todayDate.getDate() &&
                                    date.getMonth() === todayDate.getMonth() &&
                                    date.getFullYear() === todayDate.getFullYear();
                                  const isHoliday = holidayDates.some(
                                    (holiday) => holiday.toDateString() === date.toDateString()
                                  );

                                  if (isSunday) return false;           // No Sundays allowed
                                  if (isToday) return false;            // Can't select today's date
                                  if (isHoliday) return false;          // Disable holiday dates

                                  return true;
                                }}
                                placeholderText="Choose Delivery Date"
                                customInput={
                                  <input 
                                    className="form-control datepicker" 
                                    style={{ border: '1px solid #beb8b2ff', borderRadius: '0.25rem' }} 
                                  />
                                }
                              />
                              <div className="errorMessage">
                                <ErrorMessage name="deliveryDate" />
                              </div>
                            </Form.Group>
                            <Form.Group className="form-group">
                              <Form.Control
                                as="textarea"
                                name="comments"
                                className="form-control"
                                placeholder="Enter Comments"
                                onChange={handleChange}
                                value={values.comments}
                                style={{ border: '1px solid #beb8b2ff', borderRadius: '0.25rem' }}
                              />
                            </Form.Group>
                            <Button
                              type="submit"
                              variant="accent"
                              disabled={isSubmitting || isSyncing}
                            >
                              {isSubmitting || isSyncing ? (
                                <Spinner animation="border" variant="light" />
                              ) : (
                                <span>check out $ {cartTotals['final_total'].toFixed(2)}</span>
                              )}
                            </Button>
                          </FormikForm>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )
        ) : (
          <Loader />
        )}
      </div>

      <Footer />

      {/* Ask Question Modal Start */}
      <Modal
        className="alert-modal"
        size="sm"
        show={show}
        onHide={handleClose}
        onExited={handleExited}
        centered
      >
        <Modal.Body>{renderModalContent()}</Modal.Body>
      </Modal>
      {/* Ask Question Modal End */}
    </div>
  );
};

export default Cart;
